export function normalizeType(type) {
    return type.replace(/[^A-Za-z0-9]/g, '').toLowerCase();
}
